import * as React from 'react';
const GitMerge = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-git-merge", ...props },
    React.createElement("circle", { cx: "18", cy: "18", r: "3" }),
    React.createElement("circle", { cx: "6", cy: "6", r: "3" }),
    React.createElement("path", { d: "M6 21V9a9 9 0 0 0 9 9" })));
export default GitMerge;
//# sourceMappingURL=GitMerge.js.map